import * as React from 'react';

import { getTranslation, keys } from '../../../../Resources/Translations';
import { FarmasietLink } from '../../../Common/Link/FarmasietLink';
import Accordion from '../../../ReactComponents/Accordion/Accordion';
import AccordionItem from '../../../ReactComponents/Accordion/AccordionItem';
import { SectionViewModel } from '../SectionViewModel.csharp';
import { FooterSectionsProps } from './FooterSectionsProps.csharp';
import { FooterSectionsViewModel } from './FooterSectionsViewModel.csharp';

export const FooterSections = (props: FooterSectionsProps) => {
    const { sections } = props.model as FooterSectionsViewModel;

    const showCookieConsentModal = () => {
        // eslint-disable-next-line
        // @ts-ignore
        window.Cookiebot && window.Cookiebot.renew();
    };

    const renderCookieConsentLink = (section: SectionViewModel) => {
        return (
            section.showCookieConsentLink && (
                <li key={section.links.length}>
                    <div className="FooterSections__LinkItem">
                        <button onClick={showCookieConsentModal}>{getTranslation(keys['footer.seeCookieConsent'])}</button>
                    </div>
                </li>
            )
        );
    };

    return (
        <>
            <ul className="FooterSections hideOnMobile">
                {sections.map((section) => (
                    <li key={section.title} className="FooterSections__Item">
                        <h2 className="FooterSections__Heading">{section.title}</h2>
                        {section.links && (
                            <ul className="FooterSections__List">
                                {section.links.map((link, index) => (
                                    <li key={index}>
                                        <FarmasietLink model={link} className="FooterSections__LinkItem" trackingSource="Footer" />
                                    </li>
                                ))}
                                {renderCookieConsentLink(section)}
                            </ul>
                        )}
                    </li>
                ))}
            </ul>
            <div className="FooterSections__Accordion hideOnDesktop">
                <Accordion
                    allowMultipleItems
                    labelClassName="FooterSections__Heading FooterSections__Heading--Mobile"
                    collapsedIcon={<span className="Footer__SectionIcon Footer__SectionIcon--Open" />}
                    expandedIcon={<span className="Footer__SectionIcon Footer__SectionIcon--Close" />}
                >
                    {sections.map((section, index) => (
                        <AccordionItem label={section.title} key={index}>
                            {section.links && (
                                <ul className="FooterSections__List">
                                    {section.links.map((link, linkIndex) => (
                                        <li key={linkIndex}>
                                            <FarmasietLink model={link} className="FooterSections__LinkItem" trackingSource="Footer" />
                                        </li>
                                    ))}
                                    {renderCookieConsentLink(section)}
                                </ul>
                            )}
                        </AccordionItem>
                    ))}
                </Accordion>
            </div>
        </>
    );
};
